import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "starHalf"
const StarHalfIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 18.375 6.734 21.145C6.183 21.434 5.539 20.966 5.645 20.354L6.65 14.488 2.39 10.335C1.944 9.9 2.189 9.145 2.805 9.055L8.694 8.2 11.327 2.862C11.465 2.584 11.733 2.445 12.001 2.445zM9.69 9.571 4.525 10.32 8.262 13.964 7.38 19.11 10.5 17.47V7.927z" />
        </svg>
      }
    </span>
  )
}
export default StarHalfIcon
